/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.addEventListener('DOMContentLoaded', function() {
    const popupTrigger = document.querySelector('[data-important-note]');
    const modal = document.querySelector('[data-modal]');
    const modalClose = document.querySelector('[data-modal-close]');
    const html = document.querySelector('html');

    if(popupTrigger) {
        popupTrigger.addEventListener('click', function() {
            html.style.overflow = 'hidden';
            html.style.pointerEvents = 'none';
            modal.classList.add('modal--active');
            modal.style.pointerEvents = 'auto';
        });
    }

    if(modalClose) {
        modalClose.addEventListener('click', function() {
            html.style.overflow = 'auto';
            html.style.pointerEvents = 'auto';
            modal.classList.remove('modal--active');
            modal.style.pointerEvents = 'none';
        })
    }
})